import React, { ReactElement } from 'react'
import { Box, Typography } from '@mui/material'
import dayjs from 'dayjs'

type AutoTrackedDatesProps = {
  submittedDate?: string | null
  approvedDate?: string | null
  rejectedDate?: string | null
}

export let AutoTrackedDates = ({
  submittedDate,
  approvedDate,
  rejectedDate,
}: AutoTrackedDatesProps): ReactElement | null => {
  if (!submittedDate && !approvedDate && !rejectedDate) {
    return null
  }

  return (
    <Box className="grid grid-cols-3 gap-4">
      {submittedDate && (
        <Box>
          <Typography color="text.secondary" variant="caption">
            Submitted Date
          </Typography>
          <Typography variant="body2">
            {dayjs(submittedDate).format('MMM D, YYYY')}
          </Typography>
        </Box>
      )}
      {approvedDate && (
        <Box>
          <Typography color="text.secondary" variant="caption">
            Approved Date
          </Typography>
          <Typography variant="body2">
            {dayjs(approvedDate).format('MMM D, YYYY')}
          </Typography>
        </Box>
      )}
      {rejectedDate && (
        <Box>
          <Typography color="text.secondary" variant="caption">
            Rejected Date
          </Typography>
          <Typography variant="body2">
            {dayjs(rejectedDate).format('MMM D, YYYY')}
          </Typography>
        </Box>
      )}
    </Box>
  )
}
